module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA6UlEQVR4AZyRsQ4BQRRFd8UHkGgkChIfQKIRpUahUCh0Wq3eD0gkFBqVRq/S0UuUPkCjUCh8gGSdWyzz1mwkNvfszNt3704yLxP8+XwFoyjKQVKT5P/fQZwnuGA4QyWBfnZRH7r0gneQogFlKME2wZBaPVFlb4KqY2psXArURu6JbqNOcQSpyesARmnBHq4xrOAGLTDyBZ84lmEYHmHE/go7MPIFszjm3N4AdBEz6jYY+YI6cYprDzptwao9y0e+oE7ULNfYOqDZ9lmNfMHYoEFrnnFtVjf4MJ304q6WGyzyIf8LbnqDJ3gBAAD//9+CPJEAAAAGSURBVAMARgpLl3hseXAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_settlement.png
// module id = lVoS
// module chunks = 1